import { Button } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import { useMoralis } from 'react-moralis';

interface ConnectButtonProps {
  onClick: () => void;
}

export const ConnectButton = ({ onClick }: ConnectButtonProps) => {
  const { chainId, account, isWeb3Enabled } = useMoralis();

  const connectString = useMemo(() => {
    let output = '';
    if (account) {
      output += `${account.substring(0, 5)}...${account.substring(account.length - 3)}`;
    }
    if (chainId) {
      output += ` (${chainId})`;
    }
    return output;
  }, [account, chainId]);

  return (
    <Button  borderWidth={'0.1vmax'} borderColor='yellow' color='yellow' padding='1'boxSize={'fit-content'} fontWeight={'0.2'} fontSize={'1vmax'} colorScheme={isWeb3Enabled ? 'green' : 'red'  }   _hover={{ color: 'red', background:'yellow' }}onClick={onClick}>
      {isWeb3Enabled ? connectString : 'CONNECT WALLET'}
    </Button>
  );
};
